import { Controller } from 'stimulus';

const ACTIVE_CLASS = 'is-active';

export default class extends Controller {
  static targets = ['pane'];

  /**
   * @param {CustomEvent} e
   */
  switch({ detail }) {
    const { name } = detail;

    for (const paneTarget of this.paneTargets) {
      const paneName = paneTarget.getAttribute(`data-${this.identifier}-pane-name`);
      paneTarget.classList.toggle(ACTIVE_CLASS, paneName === name);
    }
  }
}
